import script from "./LearnApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./LearnApp.vue?vue&type=script&lang=ts&setup=true"

import "@/css/learn.less?vue&type=style&index=0&lang=less&external"

const __exports__ = script;

export default __exports__